import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { useCourse, canStartToday } from '@/hooks/useCourse';
import { useTelegram } from '@/hooks/useTelegram';
import { useUserStore } from '@/store/userStore';

// Карточка «Твой шаг сегодня» на главной — вход в «Путь со Славой».
export function CourseTodayCard() {
  const nav = useNavigate();
  const { haptic } = useTelegram();
  const { profile } = useUserStore();
  const { steps, progress, loading } = useCourse();

  if (loading) return null;

  const notStarted = !progress;
  const finished = !!progress?.completed_at;

  // Пройденный курс на главной — один раз (решение Славы 03.09.2026).
  // Раньше «Путь пройден 🎉» стоял над кольцом калорий вечно. Теперь:
  // первый показ помечается в базе, дальше карточка уходит — вернуть её
  // можно галочкой «показывать на главной» в Статистике.
  if (finished && progress) {
    if (progress.finished_seen_at && !progress.show_on_home) return null;
    if (!progress.finished_seen_at) {
      supabase
        .from('user_course_progress')
        .update({ finished_seen_at: new Date().toISOString() })
        .eq('user_id', progress.user_id)
        .then(() => {});
    }
  }
  const currentDay = progress?.current_day ?? 1;
  const step = steps.find((s) => s.day === currentDay);
  const hasAccess = profile?.subscription_status === 'active' || profile?.subscription_status === 'trial';
  const doneToday = !!progress && !finished && !canStartToday(progress);

  const label = notStarted ? 'Путь со Славой' : finished ? 'Путь пройден 🎉' : 'Твой шаг сегодня';
  const title = notStarted
    ? (hasAccess ? '21 день — начни свой путь' : 'Начни — первые 3 дня бесплатно')
    : finished
      ? 'Оглянись на свой путь'
      : doneToday
        ? '🌙 Шаг сделан — возвращайся завтра'
        : step ? `День ${currentDay} · ${step.title}` : `День ${currentDay}`;

  function go() {
    haptic('light');
    if (notStarted || finished || doneToday) nav('/path');
    else nav(`/path/step/${currentDay}`);
  }

  return (
    <button
      onClick={go}
      className="w-full mb-4 p-3.5 rounded-2xl bg-bg-card border border-emerald-glow/30 shadow-[0_0_22px_-10px_rgba(16,229,142,0.6)] flex items-center gap-3 text-left active:scale-[0.99] transition-transform"
    >
      <div className="w-10 h-10 rounded-xl bg-emerald-glow/15 flex items-center justify-center text-lg shrink-0">🧭</div>
      <div className="flex-1 min-w-0">
        <div className="text-[11px] text-emerald-glow uppercase tracking-wider font-medium">{label}</div>
        <div className="text-sm font-medium truncate">{title}</div>
      </div>
      <ChevronRight size={18} className="text-ink-dim shrink-0" />
    </button>
  );
}
